/* em java
public class MetaProducaoHorarioDto extends BaseEntityConta {

	private Long id;
	private LocalTime horaInicio;
	private LocalTime horaFim;
	private MetaProducaoDto metaProducao;
	
}*/

import { BaseEditModel } from "model/BaseEditModel";
import MetaProducao from "./MetaProducao";
import ApontamentoOperacao from "./ApontamentoOperacao";
import ApontamentoDefeito from "./ApontamentoDefeito";
import ApontamentoMotivoParada from "./ApontamentoMotivoParada";

export default class MetaProducaoHorario implements BaseEditModel {
    id: number;
    codigo: string | null="";
    key: string | null="";
    sequencial: number | null = 0;
    horaInicio: number;
    horaFim: number;
    apontamentos: ApontamentoOperacao[];
    apontamentosDefeito: ApontamentoDefeito[];
    apontamentosParada: ApontamentoMotivoParada[];
    metaProducao: MetaProducao | null;
    total: number = 0;
    totalDefeito: number = 0;
    
    constructor(
        id = 0,
        horaInicio = 0,
        horaFim = 0,
        metaProducao = null, 
        apontamentos = [],
        apontamentosDefeito = [],
        apontamentosParada = []
    ) {
        this.id = id;
        this.horaInicio = horaInicio;
        this.horaFim = horaFim;
        this.metaProducao = metaProducao;
        this.apontamentos = apontamentos;
        this.apontamentosDefeito = apontamentosDefeito;
        this.apontamentosParada = apontamentosParada;
    }
}